'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EResourceLink = require('./components/EResourceLink.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_EResourceLink).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-eresource-link/lib/index.js
// module id = 1237
// module chunks = 0